// Materiale fejl

export const complaintMaterialIssuesOptions: ComplaintOptions[] = [
    {
        complaintReason: "Flimmer i ruden",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Ridset rude",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Revnet rude",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Spejlbeslag",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Viskerblade",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Defekt lister på ruden",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Kamerabeslag",
        complaintArt: "Intern reklamation",
        workerFault: undefined
    },
    {
        complaintReason: "Rude ridset",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason:
            "Rudefejl - eks flimmer, spejlbeslag faldet af, flimmer o.s.v",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Løse lister",
        complaintArt: "Kundeklage",
        workerFault: undefined
    }
];

// Under montering

export const complaintDuringInstallationOption: ComplaintOptions[] = [
    {
        complaintReason: "Utæt rude",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Forkert rude monteret",
        complaintArt: "Intern reklamation",
        workerFault: true
    },
    {
        complaintReason: "Rude monteret skævt/højt/lav",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Rude revnet uden synlige stenslag",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Interiørskade",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Varmefejl",
        complaintArt: "Intern reklamation",
        workerFault: true
    },
    {
        complaintReason: "Defekte løse lister",
        complaintArt: "Intern reklamation",
        workerFault: true
    },
    {
        complaintReason: "Revnet rude under montering",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Forkert rude monteret",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Bakspejl, P-skive/Sapheetc.",
        complaintArt: "Kundeklage",
        workerFault: true
    },
    {
        complaintReason: "Regnsensor",
        complaintArt: "Kundeklage",
        workerFault: true
    }
];

// Øvrigt

export const complaintOtherIssuesOptions: ComplaintOptions[] = [
    {
        complaintReason: "Kalibrering",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Lakskade",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Ødelagte plastdele",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Viskertræk/arm/motor",
        complaintArt: "Kundeklage",
        workerFault: false
    },
    {
        complaintReason: "Kalibrering på ekstern værksted",
        complaintArt: "Uafsluttet opgave",
        workerFault: false
    },
    {
        complaintReason: "Stenslag",
        complaintArt: "Kundeklage",
        workerFault: undefined
    }
];

// Afslutning

export const complaintCompletionOptions: ComplaintOptions[] = [
    {
        complaintReason: "Afvist reklamation",
        complaintArt: "Afvist reklamation",
        workerFault: false
    }
];
